/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Line,
    LineFromJSON,
    LineFromJSONTyped,
    LineToJSON,
    MaskStatistics,
    MaskStatisticsFromJSON,
    MaskStatisticsFromJSONTyped,
    MaskStatisticsToJSON,
} from './';

/**
 * 
 * @export
 * @interface IsolationResult
 */
export interface IsolationResult {
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    contoursId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    contoursLabeledId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    ellipsesId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    histogramId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    imageContoursExoId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    maskCombinedId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    maskExoColorId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    maskExoId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    maskIsletsId: string;
    /**
     * 
     * @type {string}
     * @memberof IsolationResultResponse
     */
    maskIsletsSeparatedId: string;
    /**
     * 
     * @type {MaskStatistics}
     * @memberof IsolationResultResponse
     */
    maskStatistics: MaskStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof IsolationResultResponse
     */
    sendToIsletswipe: boolean;
    /**
     * 
     * @type {Array<Line>}
     * @memberof IsolationResultResponse
     */
    userCutLines?: Array<Line>;
}

export function IsolationResultFromJSON(json: any): IsolationResult {
    return IsolationResultFromJSONTyped(json, false);
}

export function IsolationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsolationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contoursId': json['contours_id'],
        'contoursLabeledId': json['contours_labeled_id'],
        'ellipsesId': json['ellipses_id'],
        'histogramId': json['histogram_id'],
        'imageContoursExoId': json['image_contours_exo_id'],
        'maskCombinedId': json['mask_combined_id'],
        'maskExoColorId': json['mask_exo_color_id'],
        'maskExoId': json['mask_exo_id'],
        'maskIsletsId': json['mask_islets_id'],
        'maskIsletsSeparatedId': json['mask_islets_separated_id'],
        'maskStatistics': MaskStatisticsFromJSON(json['mask_statistics']),
        'sendToIsletswipe': json['send_to_isletswipe'],
        'userCutLines': !exists(json, 'user_cut_lines') ? undefined : (json['user_cut_lines'] as Array<any>).map(LineFromJSON),
    };
}

export function IsolationResultToJSON(value?: IsolationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contours_id': value.contoursId,
        'contours_labeled_id': value.contoursLabeledId,
        'ellipses_id': value.ellipsesId,
        'histogram_id': value.histogramId,
        'image_contours_exo_id': value.imageContoursExoId,
        'mask_combined_id': value.maskCombinedId,
        'mask_exo_color_id': value.maskExoColorId,
        'mask_exo_id': value.maskExoId,
        'mask_islets_id': value.maskIsletsId,
        'mask_islets_separated_id': value.maskIsletsSeparatedId,
        'mask_statistics': MaskStatisticsToJSON(value.maskStatistics),
        'send_to_isletswipe': value.sendToIsletswipe,
        'user_cut_lines': value.userCutLines == null ? undefined : (value.userCutLines as Array<any>).map(LineToJSON),
    };
}


